export default{
    user: null,
    user_id: -1,
    is_admin: false,
    users_list: [],
    company: null,
    company_id: -1,
    visitant: {
        form_is_visible: false,
        is_registered: false,
        name: '',
        company: '',
        email: ''
    }
};